<template>
  <div class="graph-block">
    <section class="c-section c-section__graph">
      <div class="l-block">
        <div class="l-block__header">
          <TitleSub icon="survey" level="h2">
            <span class="title"
              >｢<span class="c-text--main">{{ keyword }}</span
              >｣の上位ページのコンテンツ調査</span
            >
            <ButtonDownloadManual
              :createdAt="createdAt"
              :keyword="keyword"
              :project="project"
              :tdhWordsItems="tdhWords.items"
              :isUnableDownload="isUnableDownload"
              :isCompleteData="isCompleteData"
              :isAfterManualReleaseDate="isAfterManualReleaseDate"
            />
          </TitleSub>
        </div>
        <div class="c-section__contents-block contentWords">
          <SurveyContentWords
            :createdAt="createdAt"
            :keyword="keyword"
            :project="project"
            :serpsTopItems="serpsTopItems"
            :serpsAllItems="serps.items"
            :isAfterOwnSiteReleaseDate="isAfterOwnSiteReleaseDate"
            @loadedPageVolume="loadedPageVolume"
            @completePageVolume="completePageVolume"
          />
          <SurveyHeadingCount
            :createdAt="createdAt"
            :keyword="keyword"
            :project="project"
            :serpsTopItems="serpsTopItems"
            :serpsAllItems="serps.items"
            :isAfterOwnSiteReleaseDate="isAfterOwnSiteReleaseDate"
            @loadedHeaders="loadedHeaders"
            @completeHeaders="completeHeaders"
          />
        </div>
        <div class="c-section__contents-block indexCount">
          <SurveySiteIndexCount
            :createdAt="createdAt"
            :keyword="keyword"
            :project="project"
            :serpsTopItems="serpsTopItems"
            :serpsAllItems="serps.items"
            @loadedSiteIndex="loadedSiteIndex"
            @completeSiteIndex="completeSiteIndex"
          />
          <SurveyKeywordIndexCount
            :createdAt="createdAt"
            :keyword="keyword"
            :project="project"
            :serpsTopItems="serpsTopItems"
            :serpsAllItems="serps.items"
            @loadedKeywordIndex="loadedKeywordIndex"
            @completeKeywordIndex="completeKeywordIndex"
          />
        </div>
        <SurveyTrendWords
          :createdAt="createdAt"
          :keyword="keyword"
          :project="project"
          :serpsTopItems="serpsTopItems"
          @loadedTrendWords="loadedTrendWords"
          @completeTrendWords="completeTrendWords"
        />
      </div>
    </section>
    <SurveySerpsTitles
      :createdAt="createdAt"
      :keyword="keyword"
      :project="project"
      :serpsTopItems="serpsTopItems"
      :serpsAllItems="serps.items"
      :isAfterHeaderStructuresReleaseDate="isAfterHeaderStructuresReleaseDate"
      :isAfterOwnSiteReleaseDate="isAfterOwnSiteReleaseDate"
      @loadedTdhs="loadedTdhs"
      @completeTdhs="completeTdhs"
    />
    <ModalContentPlanTutorial />
  </div>
</template>

<script>
import ButtonDownloadManual from '@/components/contentPlans/ButtonDownloadManual';
import ModalContentPlanTutorial from '@/components/contentPlans/ModalContentPlanTutorial.vue';
import SurveyContentWords from '@/components/contentPlans/SurveyContentWords';
import SurveyHeadingCount from '@/components/contentPlans/SurveyHeadingCount';
import SurveyKeywordIndexCount from '@/components/contentPlans/SurveyKeywordIndexCount';
import SurveySerpsTitles from '@/components/contentPlans/SurveySerpsTitles';
import SurveySiteIndexCount from '@/components/contentPlans/SurveySiteIndexCount';
import SurveyTrendWords from '@/components/contentPlans/SurveyTrendWords';
import TitleSub from '@/components/TitleSub';
import apiProjects from '@/api/projects';
import utils from '@/utils';
import axios from 'axios';

export default {
  props: ['createdAt', 'keyword', 'project'],

  components: {
    ButtonDownloadManual,
    ModalContentPlanTutorial,
    SurveyContentWords,
    SurveyHeadingCount,
    SurveyKeywordIndexCount,
    SurveySerpsTitles,
    SurveySiteIndexCount,
    SurveyTrendWords,
    TitleSub
  },

  data() {
    return {
      serps: {
        cancelToken: null,
        items: [],
        timeout: null,
        isLoading: true
      },
      headers: {
        isLoading: true,
        isComplete: false
      },
      keywordIndex: {
        isLoading: true,
        isComplete: false
      },
      pageVolume: {
        isLoading: true,
        isComplete: false
      },
      siteIndex: {
        isLoading: true,
        isComplete: false
      },
      tdhs: {
        isLoading: true,
        isComplete: false
      },
      tdhWords: {
        cancelTokens: [],
        count: 0,
        items: [],
        timeout: null,
        isLoading: true,
        isComplete: false
      },
      trendWords: {
        isLoading: true,
        isComplete: false
      }
    };
  },

  computed: {
    serpsTopItems() {
      return this.serps.items.slice(0, 10);
    },
    isAfterHeaderStructuresReleaseDate() {
      // dateJst日付形式で分析日が送信されているので、同じ形式に変換
      const releaseDate = this.$options.filters.dateText(
        process.env.VUE_APP_CONTENT_PLAN_ADD_HEADER_STRUCTURES_DATE,
        'YYYY-MM-DD'
      );
      // 日付レベル比較になってしまうので、リリースの翌日以降しか判定Trueを返さないようにする
      return utils.isBeforeDate(releaseDate, this.createdAt);
    },
    isAfterOwnSiteReleaseDate() {
      // dateJst日付形式で分析日が送信されているので、同じ形式に変換
      const releaseDate = this.$options.filters.dateText(
        process.env.VUE_APP_CONTENT_PLAN_ADD_OWN_SITE_DATE,
        'YYYY-MM-DD'
      );
      // 日付レベル比較になってしまうので、リリースの翌日以降しか判定Trueを返さないようにする
      return utils.isBeforeDate(releaseDate, this.createdAt);
    },
    isAfterManualReleaseDate() {
      // dateJst日付形式で分析日が送信されているので、同じ形式に変換
      const releaseDate = this.$options.filters.dateText(
        process.env.VUE_APP_CONTENT_PLAN_ADD_MANUAL_DATE,
        'YYYY-MM-DD'
      );
      // 日付レベル比較になってしまうので、リリースの翌日以降しか判定Trueを返さないようにする
      return utils.isBeforeDate(releaseDate, this.createdAt);
    },
    isUnableDownload() {
      return (
        this.serps.isLoading ||
        this.pageVolume.isLoading ||
        this.headers.isLoading ||
        this.siteIndex.isLoading ||
        this.keywordIndex.isLoading ||
        this.tdhs.isLoading ||
        this.tdhWords.isLoading ||
        this.trendWords.isLoading
      );
    },
    isCompleteData() {
      return (
        this.pageVolume.isComplete &&
        this.headers.isComplete &&
        this.siteIndex.isComplete &&
        this.keywordIndex.isComplete &&
        this.tdhs.isComplete &&
        this.tdhWords.isComplete &&
        this.trendWords.isComplete
      );
    }
  },
  created() {
    if (!this.createdAt || !this.keyword) {
      this.$router.push({
        name: 'contentPlans'
      });
    }
    this.getSerps();
  },
  destroyed() {
    clearTimeout(this.serps.timeout);
    clearTimeout(this.tdhWords.timeout);

    if (this.serps.cancelToken) {
      this.serps.cancelToken.cancel();
    }
    this.tdhWords.cancelTokens.forEach(cancelToken => {
      if (cancelToken) {
        cancelToken.cancel();
      }
    });
  },
  methods: {
    loadedPageVolume() {
      this.pageVolume.isLoading = false;
    },
    loadedHeaders() {
      this.headers.isLoading = false;
    },
    loadedSiteIndex() {
      this.siteIndex.isLoading = false;
    },
    loadedKeywordIndex() {
      this.keywordIndex.isLoading = false;
    },
    loadedTdhs() {
      this.tdhs.isLoading = false;
    },
    loadedTrendWords() {
      this.trendWords.isLoading = false;
    },
    completePageVolume() {
      this.pageVolume.isComplete = true;
    },
    completeHeaders() {
      this.headers.isComplete = true;
    },
    completeSiteIndex() {
      this.siteIndex.isComplete = true;
    },
    completeKeywordIndex() {
      this.keywordIndex.isComplete = true;
    },
    completeTdhs() {
      this.tdhs.isComplete = true;
    },
    completeTrendWords() {
      this.trendWords.isComplete = true;
    },
    getSerps() {
      const params = {
        keyword: this.keyword,
        dateJst: this.$options.filters.dateText(this.createdAt, 'YYYY-MM-DD'),
        location: 'tokyo',
        engine: 'google',
        device: 'desktop',
        fromRank: 1,
        toRank: 100
      };
      this.serps.cancelToken = axios.CancelToken.source();

      return apiProjects.serps
        .get(
          params,
          this.auth.idToken,
          this.project.id,
          this.serps.cancelToken.token
        )
        .then(response => {
          this.serps.items = response.data.items;
          this.serps.isLoading = false;

          this.setTdhWordsItems();
        })
        .catch(error => {
          if (!axios.isCancel(error)) {
            this.serps.timeout = setTimeout(this.getSerps, 30000);
          }
        });
    },
    setTdhWordsItems() {
      // 配列のコピー
      let items = JSON.parse(JSON.stringify(this.serpsTopItems));
      let isRankInOwnSite = false;

      items = items.map(item => {
        if (item.url.indexOf(this.project.siteUrl) !== -1) {
          isRankInOwnSite = true;
          item.isOwnSite = true;
        } else {
          item.isOwnSite = false;
        }
        return item;
      });

      // 2021年5月の自社情報表示リリース後のデータで、10位以内に自社サイトがない場合のみもう一枠追加
      if (this.isAfterOwnSiteReleaseDate && !isRankInOwnSite) {
        items.push({
          url: null,
          rank: null,
          isOwnSite: true
        });
      }

      items = items.map(item => {
        // 11位以下の自社サイトURLとrankの取得
        if (!item.rank) {
          for (let i = 0; i < this.serps.items.length; i++) {
            if (this.serps.items[i].url.indexOf(this.project.siteUrl) !== -1) {
              item.url = this.serps.items[i].url;
              item.rank = this.serps.items[i].rank;
              break;
            }
          }
        }
        item.h1 = null;
        item.h2 = null;
        item.title = null;
        item.description = null;
        return item;
      });

      this.tdhWords.items = items;
      this.tdhWords.items.forEach((item, index) => {
        this.getTdhWords(item, index);
      });
    },
    getTdhWords(item, index) {
      // 圏外の場合はユーザーに見れないことを伝える
      if (!item.rank) {
        return;
      }
      // URLの接尾辞が.pdfの場合はTDHの内容が表示できないため、
      // ユーザーに見れないことを伝える
      if (item.url && utils.isPdf(item.url)) {
        let obj = Object.assign({}, this.tdhWords.items[index]);
        obj.contentType = 'pdf';
        // ローディング無効
        this.tdhWords.isLoading = false;
        this.tdhWords.items.splice(index, 1, obj);
        return;
      }

      const params = {
        dateJst: this.$options.filters.dateText(this.createdAt, 'YYYY-MM-DD'),
        url: item.url
      };
      this.tdhWords.cancelTokens[index] = axios.CancelToken.source();

      return apiProjects.contentPlans.tdhWords
        .get(
          params,
          this.auth.idToken,
          this.project.id,
          this.tdhWords.cancelTokens[index].token,
          index + 1
        )
        .then(response => {
          if (response.status === 200) {
            let obj = Object.assign({}, this.tdhWords.items[index]);
            obj.h1 = response.data.h1;
            obj.h2 = response.data.h2;
            obj.title = response.data.title;
            obj.description = response.data.description;
            obj.contentType = 'html';

            this.tdhWords.items.splice(index, 1, obj);

            this.tdhWords.isComplete = this.tdhWords.items.every(item => {
              // 圏外とpdf以外の場合はh1とh2とtitleとdescriptionがあること
              return (
                item.rank === null ||
                item.contentType === 'pdf' ||
                (item.h1 !== null &&
                  item.h2 !== null &&
                  item.title !== null &&
                  item.description !== null)
              );
            });
            this.tdhWords.isLoading = false;
          } else {
            this.scheduleGetTdhWords(item, index);
          }
        })
        .catch(error => {
          if (!axios.isCancel(error)) {
            this.scheduleGetTdhWords(item, index);
          }
        });
    },
    scheduleGetTdhWords(item, index) {
      if (this.tdhWords.count < 200) {
        this.tdhWords.timeout = setTimeout(() => {
          this.getTdhWords(item, index);
          this.tdhWords.count = this.tdhWords.count + 1;
        }, 30000);
      }
    }
  }
};
</script>
